export default {

    bodyClass : function( class_ ){

        $('body').addClass( class_ )
    
    },

    bodyClassRemove : function( class_ ){

        $('body').removeClass( class_ )
    
    }, 

    showLoader : function( extra_items = undefined ){

        $('#loader').fadeIn() ;
    },

    hideLoader : function( extra_items = undefined ){

        // first action to do, remove loader
        // eslint-disable-next-line
        $('#loader').fadeOut('slow');
        // eslint-disable-next-line

        let fadeInExtra = ( extra_items != undefined ) ? extra_items : '' ; 

        $(`.fadeIn${fadeInExtra}`).fadeIn('slow');

    }, 
    
    /**
    * Helper to get current dynamic comp
    * @param (object)
    * @param (string) name of comp
    * @return (string|int|object|array) the current value
    */
    getDC : function( filters , name_comp , default_ ){

        let comp_item = filters.dynamic_components.find( d => d.name == name_comp ) ; 
        // console.log("A name_comp",name_comp,comp_item,comp_item.config.current) ; 

        if ( comp_item != undefined )
            if ( comp_item.config != undefined ) 
                if ( comp_item.config.current != undefined){
                    if ( comp_item.config.current.value != undefined && comp_item.config.current.label != undefined ){
                        if ( name_comp == 'scenario')
                            return comp_item ; 
                        else
                            return comp_item.config.current ; 
                    }
                    else
                        return { value : comp_item.config.current , label : comp_item.config.title , component : comp_item  } ; 
                }

        // console.log("B name_comp",name_comp,comp_item,comp_item.config.current) ; 

        return { value : default_ , label : '' , component : comp_item }

    },
    
  /**
  * ref: http://stackoverflow.com/a/1293163/2343
  * This will parse a delimited string into an array of
  * arrays. The default delimiter is the comma, but this
  * can be overriden in the second argument.
  */
  csvToArray : function ( strData, strDelimiter ){
    // Check to see if the delimiter is defined. If not,
    // then default to comma.
    strDelimiter = (strDelimiter || ",");

    // Create a regular expression to parse the CSV values.
    var objPattern = new RegExp(
        (
            // Delimiters.
            "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

            // Quoted fields.
            "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

            // Standard fields.
            "([^\"\\" + strDelimiter + "\\r\\n]*))"
        ),
        "gi"
        );


    // Create an array to hold our data. Give the array
    // a default empty first row.
    var arrData = [[]];

    // Create an array to hold our individual pattern
    // matching groups.
    var arrMatches = null;


    // Keep looping over the regular expression matches
    // until we can no longer find a match.
    while (arrMatches = objPattern.exec( strData )){

        // Get the delimiter that was found.
        var strMatchedDelimiter = arrMatches[ 1 ];

        // Check to see if the given delimiter has a length
        // (is not the start of string) and if it matches
        // field delimiter. If id does not, then we know
        // that this delimiter is a row delimiter.
        if (
            strMatchedDelimiter.length &&
            strMatchedDelimiter !== strDelimiter
            ){

            // Since we have reached a new row of data,
            // add an empty row to our data array.
            arrData.push( [] );

        }

        var strMatchedValue;

        // Now that we have our delimiter out of the way,
        // let's check to see which kind of value we
        // captured (quoted or unquoted).
        if (arrMatches[ 2 ]){

            // We found a quoted value. When we capture
            // this value, unescape any double quotes.
            strMatchedValue = arrMatches[ 2 ].replace(
                new RegExp( "\"\"", "g" ),
                "\""
                );

        } else {

            // We found a non-quoted value.
            strMatchedValue = arrMatches[ 3 ];

        }


        // Now that we have our value string, let's add
        // it to the data array.
        arrData[ arrData.length - 1 ].push( strMatchedValue );
    }

    // Return the parsed data.
    return( arrData );
  } , 
  
  //var csv is the CSV file with headers
  csvJSON : function (csv,strDelimiter){

    if ( strDelimiter == undefined ) strDelimiter = ';' ;

    var lines=csv.split("\n");

    var result = [];

    // NOTE: If your columns contain commas in their values, you'll need
    // to deal with those before doing the next step 
    // (you might convert them to &&& or something, then covert them back later)
    // jsfiddle showing the issue https://jsfiddle.net/
    var headers=lines[0].split(strDelimiter);

    for(var i=1;i<lines.length;i++){

        var obj = {};
        var currentline=lines[i].split(strDelimiter);

        for(var j=0;j<headers.length;j++){
            obj[slugify(headers[j])] = currentline[j];
        }

        result.push(obj);

    }

    return result; //JavaScript object
    return JSON.stringify(result); //JSON
  
  }, 


  /**
  * Build url api (2nd version full php) - these urls will progressively go to the new system R-php
  * This current function is a reproduction of a Cancer Today function with new VueJS style
  * @param (object) all values
  * @param (object) filters object
  * @param (string) specific type of graph
  * @param (string) domain for rest api url, specific rate|delay
  */
  buildUrlApi : function( values , filters , type_of_graph , domain ){

    let str_ages_group , str_statistic = '' , str_cancer = 'all' , str_population , a_params = [] , str_params = '' ; 
    str_population = values.populations.join('_') ; 

    let params = [
        { key : 'ages_group' , value : values.ages.join('_') }
    ];
    params.forEach((p)=>{ a_params.push(`${p.key}=${p.value}`) })
    str_params = a_params.join('&') ; 

    if ( values.mode.value == 'population') 
    {
        str_cancer = ( values.cancers.length > 1 ) ? '('+values.cancers.join('_')+')' : values.cancers ; 
        if ( type_of_graph == 'map') str_population = 'all' ; 
    }

    if ( values.group_populations == 1 ) str_population = `(${str_population})`;

    // overide
    if ( domain == undefined ) domain = 'rate' ;

    let base_api = ( document.location.pathname.search('dashboard') == -1 ) ? `https://gco.iarc.fr/gateway_dev/api/covid_excess/v1/04/data/${domain}` : `${filters.base_url_api}data/${domain}` ; 

    let url = `${base_api}/${values.types}/${values.sexes}/${str_population}/${str_cancer}/?${str_params}` ;

    return url ; 
  }, 

  overideTitle : function( titles , filters ){

    titles.title_l1 = titles.title_l1.replace(', '+titles.years,'')

    // console.info("titles",titles,"filters",filters.values) ; 
    
    let type_value = parseFloat(filters.values.types) ; 
    let type_str = ( type_value == 0 ) ? 'cases' : 'deaths' , short_title_l1  ;
    let str_age = `${filters.values.age_select[0].label}-${filters.values.age_select[1].label} ages` ;  

    if ( filters.values.key == 'asr'){
        short_title_l1 = `WFP2015 per 100 000 *` ; 
        titles.title_l1 = titles.title_l1.replace('Age-Standardized Rate (World) per 100 000',short_title_l1) ;
    }
    else if ( filters.values.key == 'total'){
        short_title_l1 = `Estimated number of ${type_str}` ; 
        titles.title_l1 =  titles.title_l1.replace('Absolute numbers',short_title_l1) ; 
        // titles.title_l1 = `${short_title_l1}, cervix uteri` ;
    }
    else if ( filters.values.key == 'diff_vs_S0'){
        short_title_l1 = 'Difference in numbers versus S0';
    }
    else if ( filters.values.key == 'diff_vs_D0'){
        short_title_l1 = 'Difference in numbers versus D0';
    }

    titles.short_title_l1 = short_title_l1 ;

    // replace age pattern
    titles.title_l1 = titles.title_l1.replace(titles.ages,str_age) ; 

    // titles.title_l1 = titles.title_l1 + `, ${str_age}` ; 

    let delay_ = '' ; 
    //console.info("filters.values.scenario.current.value",filters.values.scenario.current.value);
    if ( filters.values.scenario.current.value == 3 ) delay_ = ` (${filters.values.delay.current.label})` ; 
    titles.title_l3 = `Scénario ${filters.values.scenario.current.value}${delay_}` ; // : '' ; 


    titles.short_title_l1 = short_title_l1 ; 

    return titles ; 

  }

}